/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentMetaDataDto } from '../../models/document-meta-data-dto';

export interface GetDocumentMetadataById$Params {
  idDocument: string;
}

export function getDocumentMetadataById(
  http: HttpClient,
  rootUrl: string,
  params: GetDocumentMetadataById$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<DocumentMetaDataDto>> {
  const rb = new RequestBuilder(rootUrl, getDocumentMetadataById.PATH, 'get');
  if (params) {
    rb.path('idDocument', params.idDocument, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentMetaDataDto>;
    })
  );
}

getDocumentMetadataById.PATH = '/v2/documents/{idDocument}';
